import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public"
export default class extends Controller {
  connect() {
    //document.documentElement.style.cursor = 'none';
  }
}
